import { useEffect } from 'react';

export const useTabTitle = () => {
  useEffect(() => {
    let originalTitle = document.title;

    const titleElement = document.querySelector('title');
    if (!titleElement) return;

    const observer = new MutationObserver(() => {
      const currentTitle = document.title;
      if (
        currentTitle !== '🧸 We miss you! Come back! | BST' &&
        currentTitle !== '✨ Toys are waiting! | BST'
      ) {
        originalTitle = currentTitle;
      }
    });

    observer.observe(titleElement, { subtree: true, characterData: true, childList: true });

    const handleVisibilityChange = () => {
      if (document.hidden) {
        const alternateTitles = ['🧸 We miss you! Come back! | BST', '✨ Toys are waiting! | BST'];
        const randomTitle = alternateTitles[Math.floor(Math.random() * alternateTitles.length)];
        document.title = randomTitle;
      } else {
        document.title = originalTitle;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      observer.disconnect();
    };
  }, []);
};
